module.exports = __webpack_public_path__ + "media/images/escu_gris-244d94149bb8a013f073b7ad05f5f2d7.jpg";